
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ReloadIcon from '~/components/svg/ReloadIcon';
import MyPagination from '@/components/ui/MyPagination.vue';
import FastFilters from '@/themes/farmacie/components/Catalog/FastFilters.vue';
import FarmacieLoader from '@/themes/farmacie/components/FarmacieLoader.vue';

export default {
    props: ['url', 'loading', 'isFiltersEmpty'],
    components: {
        FarmacieLoader,
        FastFilters,
        MyPagination,
        ReloadIcon,
        ProductItemContent: () => import('@/components/product/ProductItemContent'),
        ProductAgent: () => import('@/components/product/ProductAgent'),
        ProductItemContentNovaPorta: () => import('@/components/NovaPorta/Product/ProductItemContentNovaPorta.vue'),
        FarmacieProductCart: () => import('@/themes/farmacie/components/Product/ProductCart.vue')
    },
    computed: {
        ...mapGetters('products', ['getProducts', 'getPage', 'getTotalCount', 'getTotalPagesCount', 'getCategoryDescription']),
        ...mapGetters({
            activeFiltersToSend: 'filters/activeFiltersToSend',
            sortingType: 'filters/sortingType',

            globalSettings: 'global/globalSettings',
            isFarmacie: 'global/getIsFarmacie',
            isNovaPorta: 'global/getIsNovaPorta'
        }),
        computedClass() {
            let classes = this.globalSettings.filter_display === 'vertical' ? 'product__items--sidebar' : '';
            const countItemsIncCatalog = this.globalSettings.additional_settings?.products_in_catalog;
            const countItemsIncRow = this.globalSettings.additional_settings?.products_in_row;
            if (this.isFarmacie) {
                classes += ' product__items--farmacie';
            }

            if (countItemsIncCatalog === 'one_in_row') {
                classes += ' product__items--one-in-row';
            }

            if (countItemsIncCatalog === 'two_in_row') {
                classes += ' product__items--two-in-row';
            }

            if (!this.isFiltersEmpty) {
                if (countItemsIncRow === '4') {
                    classes += ' product__items--with-fiters--four-in-row';
                }
                if (countItemsIncRow === '3') {
                    classes += ' product__items--with-fiters--three-in-row';
                }
            }

            if (this.isFiltersEmpty) {
                if (countItemsIncRow === '4') {
                    classes += ' product__items--without-fiters--four-in-row';
                }
                if (countItemsIncRow === '3') {
                    classes += ' product__items--without-fiters--three-in-row';
                }
            }

            return classes.trim();
        }
    },
    data() {
        return {
            pageSize: 8,
            requestInProgress: false,
            observer: null
        };
    },
    methods: {
        ...mapMutations('products', ['addProducts', 'setProducts', 'setPage', 'setTotalPagesCount']),
        ...mapMutations({
            SET_IS_RANGE_SLIDER_TRIGGERED: 'filters/SET_IS_RANGE_SLIDER_TRIGGERED'
        }),
        ...mapActions('products', ['changePage']),
        resetPage() {
            this.SET_IS_RANGE_SLIDER_TRIGGERED(false);
            this.addProducts([]);
            this.changePage({
                page: this.$route.query.page || 1,
                query: this.$route.query
            });
            this.initObserver();
        },
        async loadMore(currentPage) {
            this.SET_IS_RANGE_SLIDER_TRIGGERED(false);
            if (this.requestInProgress || currentPage === +this.getPage) {
                return;
            }

            this.requestInProgress = true;

            if (currentPage) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                // this.setPage(currentPage);
                // this.defineActivePage(currentPage);
                await this.changePage({
                    page: currentPage,
                    query: this.$route.query
                });

                // this.$emit('fetch-products');

                this.requestInProgress = false;
            } else {
                let page = parseFloat(this.getPage) + 1;
                await this.changePage({
                    page,
                    query: this.$route.query
                });

                try {
                    let result = await this.$axios.$get(this.url + '?page=' + page, {
                        params: {
                            filters: JSON.stringify(this.activeFiltersToSend),
                            sortBy: this.sortingType
                        }
                    });

                    if (result.data && result.data.products) {
                        this.addProducts(result.data.products);
                        this.setTotalPagesCount(result.pages);
                    }
                } finally {
                    this.requestInProgress = false;
                }
            }
        },
        defineActivePage(pageId) {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: pageId
                }
            });
        },
        handleIntersection(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.requestInProgress) {
                    this.loadMore();
                }
            });
        },

        observeLoadMoreButton() {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1 // Adjust this threshold as needed
            };

            this.observer = new IntersectionObserver(this.handleIntersection, options);
            const buttonElement = this.$refs.loadMoreButton;

            if (buttonElement) {
                this.observer.observe(buttonElement);
            }
        },
        initObserver() {
            this.observeLoadMoreButton();
        }
    },
    mounted() {
        this.resetPage();
        window.scrollTo(0, 0);
    },

    beforeDestroy() {
        this.addProducts([]);
        this.setPage(1);
    }
};
